import { ReactNode } from "react";
import Link, { LinkProps } from "next/link";
import { prependLocaleToPath, useLocale } from "../../../helpers/locale";
import { useHrefKeepingRedirectionParams } from "../../../helpers/navigation";

interface Props extends Pick<LinkProps, "passHref" | "legacyBehavior"> {
  children: ReactNode;
  href: string;
}

export function LinkWrapper({ href, ...props }: Props) {
  const { locale } = useLocale();
  const { href: hrefKeepingRedirectionParams } =
    useHrefKeepingRedirectionParams(href);

  return (
    <Link
      href={prependLocaleToPath(hrefKeepingRedirectionParams, locale)}
      {...props}
      shallow
    />
  );
}
